import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { updateMessageOptions } from "../../../store/Slices/MessageOptionsSlice";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import SearchLocationDropdown from "./SearchLocationDropdown";
import TextTranslate from "../../../utils/TextTranslate";
import { useMapProvider } from "../../../hooks/useMapProvider";

export default function SendLocationModal() {
  const dispatch = useAppDispatch();
  const MessageOptionsData = useAppSelector((state) => state.MessageOptions);
  const { provider } = useMapProvider();

  const close = () => {
    dispatch(updateMessageOptions({ show_send_location_modal: false }));
  };

  return (
    <Dialog
      open={MessageOptionsData.show_send_location_modal}
      as="div"
      className="relative z-[100]"
      onClose={close}
    >
      <div className="fixed inset-0 bg-black/40 backdrop-blur-sm">
        <div className="flex min-h-full items-end justify-center p-0 sm:items-center sm:p-4">
          <DialogPanel className="relative flex max-h-[90dvh] w-full max-w-md flex-col overflow-hidden rounded-t-[1.25rem] bg-primary shadow-2xl sm:rounded-2xl">
            <DialogTitle className="shrink-0 border-b border-black/[0.06] px-4 py-3.5 text-center text-[17px] font-semibold tracking-tight text-darkText dark:border-white/[0.08]">
              <TextTranslate text="Share Location" />
              <div className="mt-0.5 text-[12px] font-medium text-lightText">
                {provider === "yandex" ? "Yandex Maps" : "Google Maps"}
              </div>
            </DialogTitle>

            <div className="min-h-0 flex-1 overflow-hidden">
              <SearchLocationDropdown onClose={close} />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
